import CloseIcon from '@mui/icons-material/Close'
import { Box, IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'

import { UqLogoWhite } from '../../UqLogoWhite'

const LogoWrapper = styled(Box)({
  backgroundColor: '#51247a',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
})

type Props = {
  height: number
  showCloseButton: boolean
  onClose: () => unknown
}

export const MenuDrawerLogoBar = ({ height, showCloseButton, onClose }: Props) => {
  return (
    <Box sx={{ height }}>
      <LogoWrapper sx={{ minHeight: height }}>
        <UqLogoWhite width={150} height={45} />
        {showCloseButton && (
          <Box sx={{ position: 'absolute', right: 8 }}>
            <IconButton onClick={onClose}>
              <CloseIcon sx={{ color: '#FFF' }} />
            </IconButton>
          </Box>
        )}
      </LogoWrapper>
    </Box>
  )
}
